import ApiService from '../api.services';

const TeamService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/team');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/team/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {

        try {
            const data = {
                team: form
            }
            const res = await ApiService.post('/api/team', data);
            return res.data;
        } catch (error) {
            throw error;
        }

    },
    update: async function (id, form) {
        const data = {
            team: form
        }
        try {
            const response = await ApiService.put(`/api/team/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/team/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default TeamService;

export { TeamService };

